import React from 'react';

import ModalBase from './ModalBase';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';

import TModalBase from './@types/TModalBase';
import TModalHeader from './@types/TModalHeader';
import TModalFooter from './@types/TModalFooter';
import TBasicModal from './@types/TBasicModal';

const BasicModalWithFooter = ({
  title,
  ariaLabel,
  children,
  buttons,
  buttonsAlignmentDesktop,
  buttonsAlignmentMobile,
  contentClassName,
  onClose,
  onBack,
  isBottomSheet,
  ...rest
}: TModalBase & TModalHeader & TModalFooter & TBasicModal) => (
  <ModalBase kind={isBottomSheet ? 'bottom-sheet' : 'basic'} ariaLabel={ariaLabel ?? title} onClose={onClose} {...rest}>
    <ModalHeader onClose={onClose} onBack={onBack} title={title} />
    <ModalContent className={contentClassName}>{children}</ModalContent>
    <ModalFooter
      buttons={buttons}
      buttonsAlignmentDesktop={buttonsAlignmentDesktop}
      buttonsAlignmentMobile={buttonsAlignmentMobile}
    />
  </ModalBase>
);

export default BasicModalWithFooter;
